// Regras puras do cadastro de romaneio manual (PO1-3300): rótulos das listas
// de apoio, form ⇄ registro da API e validação dos obrigatórios.

export const UNIDADES = [
  { value: "kg", label: "KG - Peso (KG) das mercadorias" },
  { value: "fxvc", label: "FXVC - Valor fixo por Veículo" },
  { value: "fxnf", label: "FXNF - Valor fixo por NF" },
];

// Opções da Unidade; um valor antigo fora da lista (ex.: '1') aparece como
// "<valor> (legado)" para a edição de outros campos não obrigar a trocá-lo.
export function opcoesUnidade(atual) {
  const lista = UNIDADES.map((u) => ({ id: u.value, _rotulo: u.label }));
  const valor = atual === null || atual === undefined ? "" : String(atual);
  if (valor && !UNIDADES.some((u) => u.value === valor)) lista.push({ id: valor, _rotulo: `${valor} (legado)` });
  return lista;
}

export const OBRIGATORIOS = ["codigo", "dataSaida", "idTipoVeiculo", "idCidade", "idTransportadora", "idRota"];

export const ROTULOS = {
  codigo: "Código",
  dataSaida: "Data de embarque",
  idTipoVeiculo: "Tipo de veículo",
  idCidade: "Cidade",
  idTransportadora: "Transportadora",
  idRota: "Rota",
  kmTotal: "Km total",
  tipoRoma: "Tipo roma",
  dtPrevColeta: "Previsão de coleta",
};

export const nomeTransportadora = (t) => (t && (t.fantasia || t.razaoSocial || (t.id ? `#${t.id}` : ""))) || "";
export const rotuloRota = (r) => (r ? [r.codigo, r.nome].filter(Boolean).join(" - ") || `#${r.id}` : "");
export const rotuloItem = (i) => (i ? i.nome || i.descricao || i.codigo || `#${i.id}` : "");

const str = (v) => (v === null || v === undefined ? "" : String(v));

export const FORM_VAZIO = {
  codigo: "",
  dataSaida: "",
  idTipoVeiculo: "",
  idEstado: "",
  idCidade: "",
  idTransportadora: "",
  idRota: "",
  idNegocio: "",
  idTipoServico: "",
  calculo: "",
  tipoRomaneio: "",
  idModal: "",
  tipoRoma: "",
  kmTotal: "",
  placaVeiculo: "",
  motorista: "",
  hrSaida: "",
  remessa: "",
  dtPrevColeta: "",
};

// Registro da API → valores do form (tudo string; km com vírgula).
export function formDoRegistro(r) {
  if (!r) return { ...FORM_VAZIO };
  return {
    codigo: str(r.codigo),
    dataSaida: str(r.dataSaida).slice(0, 10),
    idTipoVeiculo: str(r.idTipoVeiculo),
    idEstado: str(r.idEstado),
    idCidade: str(r.idCidade),
    idTransportadora: str(r.idTransportadora),
    idRota: str(r.idRota),
    idNegocio: str(r.idNegocio),
    idTipoServico: str(r.idTipoServico),
    calculo: str(r.calculo),
    tipoRomaneio: str(r.tipoRomaneio),
    idModal: str(r.idModal),
    tipoRoma: str(r.tipoRoma),
    kmTotal: r.kmTotal === null || r.kmTotal === undefined ? "" : String(r.kmTotal).replace(".", ","),
    placaVeiculo: str(r.placaVeiculo),
    motorista: str(r.motorista),
    hrSaida: str(r.hrSaida),
    remessa: str(r.remessa),
    dtPrevColeta: str(r.dtPrevColeta).slice(0, 16),
  };
}

// "12,5" / "12.5" → 12.5; "" → null; inválido → NaN.
export function parseKm(v) {
  const s = str(v).trim();
  if (!s) return null;
  if (!/^\d+([.,]\d+)?$/.test(s)) return NaN;
  return Number(s.replace(",", "."));
}

// { campo: mensagem } dos obrigatórios e dos formatos que a tela confere.
export function validarForm(form) {
  const erros = {};
  OBRIGATORIOS.forEach((k) => {
    if (!str(form[k]).trim()) erros[k] = "Obrigatório.";
  });
  if (Number.isNaN(parseKm(form.kmTotal))) erros.kmTotal = "Informe um número (ex.: 125,5).";
  return erros;
}

const idOuNull = (v) => (str(v) ? Number(v) : null);
const textoOuNull = (v) => str(v).trim() || null;

// Form → corpo do POST/PUT. Manda todos os campos (vazio = null limpa no PUT).
export function payloadDoForm(form) {
  return {
    codigo: str(form.codigo).trim(),
    dataSaida: form.dataSaida,
    idTipoVeiculo: idOuNull(form.idTipoVeiculo),
    idCidade: idOuNull(form.idCidade),
    idTransportadora: idOuNull(form.idTransportadora),
    idRota: idOuNull(form.idRota),
    idNegocio: idOuNull(form.idNegocio),
    idTipoServico: idOuNull(form.idTipoServico),
    calculo: form.calculo || null,
    tipoRomaneio: textoOuNull(form.tipoRomaneio),
    idModal: idOuNull(form.idModal),
    tipoRoma: textoOuNull(form.tipoRoma),
    kmTotal: parseKm(form.kmTotal),
    placaVeiculo: textoOuNull(form.placaVeiculo) ? str(form.placaVeiculo).trim().toUpperCase() : null,
    motorista: textoOuNull(form.motorista),
    hrSaida: textoOuNull(form.hrSaida),
    remessa: textoOuNull(form.remessa),
    dtPrevColeta: textoOuNull(form.dtPrevColeta),
  };
}

// Erros de campo de uma resposta 400 ({ field, campos }).
export function errosDoServidor(e) {
  const data = e && e.response && e.response.status === 400 && e.response.data;
  if (!data) return {};
  const erros = {};
  (Array.isArray(data.campos) ? data.campos : []).forEach((k) => {
    erros[k] = "Obrigatório.";
  });
  if (data.field && !erros[data.field] && data.field !== "id") erros[data.field] = data.message || data.error || "Inválido.";
  return erros;
}
